'use strict';
const goldFileListUtils = require('./gold-file-list-utils');
module.exports = function GoldFileFilteredList(goldFileListPreferences, optional) {
	let currentFiles = [], calculatedList = {};
	const self = this,
		recalculateFileList = (optional && optional.recalculateFileList) || goldFileListUtils.recalculateFileList,
		recalculate = (files) => {
			currentFiles = files || currentFiles || [];
			calculatedList = recalculateFileList(currentFiles, goldFileListPreferences);
		};

	calculatedList = recalculateFileList([], goldFileListPreferences);

	self.recalculate = () => recalculate();

	self.setFiles = files => {
		recalculate(files);
	};
	self.hasLegacyTeamFiles = () => {
		return !!currentFiles.find(file => file.context.teamFile);
	};
	self.setListSortType = (sortType) => {
		goldFileListPreferences.setSortType(sortType);
		recalculate();
	};
	self.getCurrentTags = () => calculatedList.tags.slice(0);

	self.getCurrentFilteredTags = () => calculatedList.filteredTags.slice(0);

	self.setListFilterType = (filterType) => {
		goldFileListPreferences.setFilterType(filterType);
		recalculate();
	};
	self.setListFilterInvert = (doInvert) => {
		goldFileListPreferences.setListFilterInvert(doInvert);
		recalculate();
	};
	self.getCurrentFilteredList = () => calculatedList.visibleFiles;

	self.hasFiles = () => !!(currentFiles && currentFiles.length);
	self.getCurrent = () => {
		return calculatedList;
	};
};
